// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"style_breadcrumbs__3yQ_m","current":"style_current__D-Pfn","arrow":"style_arrow__CprVP"};